import { ApiResource } from '@/core/models/api-resource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Activity } from './activity.interface';
import { ActivityService } from './activity.service';

const service = new ActivityService();

export interface ActivityState {
   activitiesOverview?: ApiResource<Array<Activity>>;
}

const ActivityStore: Module<ActivityState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getActivities(context, payload: { candidateId: number; query: LocationQuery }) {
         const response = await service.getActivities(payload.candidateId, payload.query);
         return response;
      },
   },
};

export default ActivityStore;
